import './frontend.css';

// Post Tile Animation Handler
const initPostTiles = () => {
	const tiles = document.querySelectorAll('.post-tile:not(.animate-in)');
	
	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const tile = entry.target;
				const delay = parseFloat(tile.dataset.animationDelay) || 0;
				
				setTimeout(() => {
					tile.classList.add('animate-in');
				}, delay * 1000);
				
				observer.unobserve(tile);
			}
		});
	}, {
		threshold: 0.1,
		rootMargin: '0px 0px -50px 0px'
	});
	
	tiles.forEach(tile => observer.observe(tile));
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initPostTiles);
} else {
	initPostTiles();
}

// Re-initialize on dynamic content changes
if (typeof MutationObserver !== 'undefined') {
	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === 'childList') {
				initPostTiles();
			}
		});
	});
	
	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
}
